import { render } from "./App.vue?vue&type=template&id=0b106058"
const script = {}

import exportComponent from "/home/rlabrovi/Local Sites/vertikal/app/public/wp-content/plugins/climbing-card/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__